import notHandledHere from './notHandledHere';
import { constants, dbViews, globalConfig } from 'lib_ui-services';

const { minFullTextSearchTermLength } = globalConfig();
const { LOCAL_ONLY_SEARCH_REASONS } = dbViews;

const _p = { dbViews };
export const _private = _p;

export default {
    verb: 'doingGetMore',
    excludedNamespaceRelations: notHandledHere,
    description: 'Resync the current relation',
    //this is the actual logic:
    logic: doingGetMore
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").WorkflowStack} WorkflowStack
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @param {{
 *   data: T;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   workflowStack: WorkflowStack[];
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {T}
 */
async function doingGetMore({ data, context, dispatch }) {
    const { dbViewName } = data;
    const { namespace, relation } = context;
    const dbView = await _p.dbViews.getDbView(namespace, relation, dbViewName);
    const results = await dbView.getNextPage();
    const message = getMessage(results, dbView.localOnlySearchReason);
    dispatch(
        {
            message,
            timeout: 5000,
            addToList: false,
            isError: false, //todo: gl2025 remove
            variant: 'info',
            type: constants.notificationTypes.TOAST
        },
        {
            verb: 'pop',
            namespace: 'application',
            relation: 'notification'
        }
    );
}

/**
 * Says what Get More actually did.
 *
 * Only the empty case used to be reported, which left "the toast did not appear" as the sole sign
 * that anything had been retrieved (#2043). That is hard to read at the best of times, and
 * misleading under a search too short to reach the server: those records arrive from a plain sync
 * of the relation rather than from a search for the user's term, so they routinely do not include
 * what the user is looking for and the grid does not visibly change (#2040). Say so, and say what
 * would search for it.
 *
 * @param {object[]} [results] - the records this page retrieved
 * @param {string} [localOnlySearchReason] - see `getLocalOnlySearchReason`
 * @returns {string}
 */
function getMessage(results, localOnlySearchReason) {
    const count = results?.length ?? 0;
    if (count === 0) return 'No additional records were found.';

    const retrieved = `Retrieved ${count} more record${count === 1 ? '' : 's'}.`;
    if (localOnlySearchReason === LOCAL_ONLY_SEARCH_REASONS.termTooShort) {
        return `${retrieved} Type ${minFullTextSearchTermLength} or more characters to search all records.`;
    }
    return retrieved;
}
